module.exports = __webpack_public_path__ + "pin_red.b8aee4.png";